import { render, staticRenderFns } from "./chatMessageView.vue?vue&type=template&id=e8f1a762&scoped=true&"
import script from "./chatMessageView.vue?vue&type=script&lang=ts&"
export * from "./chatMessageView.vue?vue&type=script&lang=ts&"
import style0 from "./chatMessageView.vue?vue&type=style&index=0&id=e8f1a762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f1a762",
  null
  
)

export default component.exports